'use client'

import { ProgressProvider as ProgressBarProvider } from '@bprogress/next/app'

export const ProgressProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  return (
    <ProgressBarProvider
      height='4px'
      color='hsl(var(--primary-300))'
      options={{ showSpinner: false }}
      shallowRouting
    >
      {children}
    </ProgressBarProvider>
  )
}
